exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page[data-v-57b507a0]{overflow:hidden}.bg[data-v-57b507a0]{width:120%;height:400px;text-align:center;color:#FFF;font-size:32px;margin-bottom:50px;border-radius:0 0 50% 50% / 20%}.bg.success[data-v-57b507a0]{background-color:#409EFF}.bg.fail[data-v-57b507a0]{background-color:#ff1736}.bg .icon[data-v-57b507a0]{padding-bottom:50px}.btn-box[data-v-57b507a0]{position:fixed;bottom:5%;width:90%}.btn-box .retry[data-v-57b507a0]{margin-bottom:10px}\n", ""]);

// exports
